var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 30.2498V31.6665L18.4167 35.2082L8.5 32.5165V34.4998H0V18.9165H11.3333L20.1167 22.1748C21.5333 22.7415 22.6667 24.2998 22.6667 25.9998H25.5C27.9083 25.9998 29.75 27.8415 29.75 30.2498ZM5.66667 31.6665V21.7498H2.83333V31.6665H5.66667ZM26.775 29.6832C26.4917 29.1165 26.0667 28.8332 25.5 28.8332H17.85C17.1417 28.8332 16.2917 28.6915 15.5833 28.5498L12.325 27.4165L13.175 24.7248L16.575 25.8582C17 25.8582 19.8333 25.9998 19.8333 25.9998C19.8333 25.4332 19.55 25.0082 18.9833 24.8665L10.7667 21.7498H8.5V29.5415L18.4167 32.2332L26.775 29.6832Z",
    fill: "#F59D81"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.082,
    cy: 10.5,
    r: 9.25,
    stroke: "#E85936",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 16L18.688 11.38V10.764H18.996C19.4907 10.764 19.906 10.7173 20.242 10.624C20.5874 10.5307 20.858 10.3767 21.054 10.162C21.25 9.94733 21.3667 9.65333 21.404 9.28H18.688V8.384H21.39C21.3247 8.03867 21.194 7.75867 20.998 7.544C20.802 7.32 20.536 7.15667 20.2 7.054C19.8734 6.95133 19.472 6.9 18.996 6.9H18.688V6.004H24.484V6.9H21.838C22.0527 7.07733 22.23 7.28733 22.37 7.53C22.51 7.77267 22.5987 8.05733 22.636 8.384H24.484V9.28H22.664C22.5987 9.96133 22.3374 10.4933 21.88 10.876C21.432 11.2493 20.8347 11.4873 20.088 11.59L22.762 16H21.334Z",
    fill: "#E85936"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsop);
export default __webpack_public_path__ + "static/media/esop.89c23045a0d5126a77c9cb76da298cfd.svg";
export { ForwardRef as ReactComponent };